import React from 'react'
import PropTypes from 'prop-types'

function PageStatus({ status, error }) {
  if (status === 'loading') return <p className="lg-status">Loading...</p>
  if (error && error.status === 404) return <p className="lg-status">Page not found</p>
  return <p className="lg-status">Could not load page: {error && error.message}</p>
}

PageStatus.propTypes = {
  status: PropTypes.string,
  error: PropTypes.shape({
    status: PropTypes.number,
    message: PropTypes.string,
  }),
}

export default PageStatus
